import {
  Box,
  Typography,
  Dialog,
  DialogContent,
  useTheme,
  useMediaQuery,
  DialogActions,
} from "@mui/material";
import styles from "../../screens/Requirement/Requirement.module.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatDate, formatTime } from "../../utils/const";
import {
  getAppliedCandidateById,
  RemoveCandidateFromJob,
} from "../../redux/jobTimeline/jobTimelineSlice";
import { useDispatch, useSelector } from "react-redux";

const changeCandidateStatus = (value) => {
  let status;
  if (value === "accepted") {
    status = "Accepted";
  } else if (value === "not_fit") {
    status = "Not Fit";
  } else if (value === "latter") {
    status = "Latter";
  } else if (value === "waiting") {
    status = "Waiting";
  }
  return status;
};

const SalesRecruiter = ({
  image,
  name,
  skill,
  location,
  status,
  btn1,
  btn2,
  candidate,
  jobdata,
}) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [actionName, setActionName] = useState("");
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [openManage, setOpenManage] = useState(false);

  const dispatch = useDispatch();
  const jobtimelineStatus = useSelector((state) => state.jobtimeline?.status);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleManageClickOpen = () => {
    setOpenManage(true);
  };

  const handleManageClose = () => {
    setOpenManage(false);
  };

  const handleOnClickConfirmRemove = () => {
    let queryParams = `job_id=${jobdata?.job_id}&candidate_user_id=${candidate?.candidate_user_id}&candidate_resume_id=${candidate?.candidate_resume_id}`;
    dispatch(RemoveCandidateFromJob(queryParams));
  };

  useEffect(() => {
    if (jobtimelineStatus === "remove_candidate_suceed") {
      let jobID = jobdata?.job_id;
      dispatch(getAppliedCandidateById(jobID));
      handleManageClose();
    }
  }, [jobtimelineStatus]);

  useEffect(() => {
    if (candidate) {
      setActionName(candidate?.timeline_apply_status);
    }
  }, [candidate]);

  const buttonColor = btn2 === "Viewed" ? "#4285f4" : "#3856a6";
  return (
    <Box
      className={styles.recruiter_job_post}
      sx={{ border: "1px solid #f5f5f5" }}
    >
      <Box>
        {/* <img src={image} alt="" /> */}
        <span>
          <Typography>
            Candidate Name: <b>{name}</b>
          </Typography>
          {/* <Typography>
            Job Profile: <b>{skill}</b>
          </Typography>
          <Typography>
            Job Type: <b>{jobdata?.job_type}</b>
          </Typography> */}
          <Typography>
            Location: <b>{location}</b>
          </Typography>
          <Typography sx={{ margin: "0 !important" }}>
            Visa: <b>{status}</b>
          </Typography>
        </span>
      </Box>

      <Box sx={{ alignItems: "center", flexDirection: "column" }}>
        <span
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "5px",
            justifyContent: "space-between",
          }}
        >
          <Typography>
            <b>
              {candidate?.created_at && formatDate(candidate?.created_at)}
              {", "}
              {candidate?.created_at && formatTime(candidate?.created_at)}
            </b>
          </Typography>
        </span>
        <span>
          <button
            style={{
              backgroundColor: "#f2f2f2",
              alignSelf: "flex-end",
              marginRight: "10px",
              color: "black",
              cursor: "not-allowed",
              pointerEvents:"none"
            }}
            disabled
          >
            {changeCandidateStatus(actionName)}
          </button>

          <button
            style={{ backgroundColor: buttonColor, alignSelf: "flex-end" }}
            onClick={handleManageClickOpen}
          >
            {btn1}
          </button>
        </span>
      </Box>
      <Dialog
        fullScreen={fullScreen}
        open={openManage}
        // onClose={handleManageClose}
        aria-labelledby="responsive-dialog-title"
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogContent>
          <Box className={styles.text_requirement}>
            <Typography>
              <b>
                Are you Sure You want to remove candidate from this job applied
                ?
              </b>
            </Typography>
          </Box>
          <DialogActions>
            <Box className={styles.update_btn}>
              <button onClick={handleOnClickConfirmRemove}>Yes</button>
              <span className={styles.no_btns} style={{ marginLeft: "10px" }}>
                <button onClick={handleManageClose}>No</button>
              </span>
            </Box>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default SalesRecruiter;
